"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTpaDto = void 0;
const mapped_types_1 = require("@nestjs/mapped-types");
const create_tpa_dto_1 = require("./create-tpa.dto");
class UpdateTpaDto extends (0, mapped_types_1.PartialType)(create_tpa_dto_1.CreateTpaDto) {
}
exports.UpdateTpaDto = UpdateTpaDto;
